import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Keeps the product-page entries pill in sync with the selected variant.
 *
 * The pill is static Liquid in the media column, which the variant picker does
 * not re-render, so on every variant update this element swaps itself for the
 * freshly rendered pill in the fetched section HTML. Same pattern as the media
 * gallery (assets/media-gallery.js).
 *
 * @extends {Component}
 */
class SfSweepsPill extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const target = this.closest('.shopify-section, dialog');
    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data?.html;
    if (!source) return;

    const next = source.querySelector('sf-sweeps-pill');
    if (next) this.replaceWith(next);
  };
}

if (!customElements.get('sf-sweeps-pill')) {
  customElements.define('sf-sweeps-pill', SfSweepsPill);
}
